import "./FoodAndIngredients.module.css";
import Header from "@/reusable_sections/Header";
import Traceability from "./sections/Traceability";
import FoodApplications from "./sections/FoodApplications";
import TechnologiesOverview from "./sections/TechnologiesOverview";
import Services from "./sections/Services";
import Cta from "./sections/Cta";
import Footer from "@/reusable_sections/Footer";
export default function FoodAndIngredientsPage() {
  return <div>
      <Header />
      <Traceability />
      <FoodApplications />
      <TechnologiesOverview />
      <Services />
      <Cta />
      <Footer />
    </div>;
}